import { styled } from "@linaria/react";
import { color } from "..";

export const MIN_ROW_HEIGHT = 48;

const Tr = styled.tr`
  display: flex;
  // On chrome, will-change: width; allow to mark tr element for gpu acceleration
  // allowing to reflow the table and recompute cell width.
  will-change: width;

  thead & {
    min-height: 40px;
  }

  tbody & {
    min-height: 48px;
  }

  :not(:first-child) {
    border-top: 1px solid ${color.titanium200};
  }
`;

export default Tr;
